import { ref } from "vue";
import { useStore } from "vuex";
import Swal from "sweetalert2";
import useTitularesLista from "./useTitularesLista";
// import { useRouter } from "vue-router";

const useDialogCrearTitulares = () => {
    const displayModal = ref(false);
    // const router = useRouter();

    const { getTitulares, getTitularesInfo } = useTitularesLista();

    const store = useStore();

    // Funcion para crear Titular
    const crearNuevoTitular = async (form) => {
        const data = await store.dispatch("admin/crearNuevoTitular", form);
        // const { status, message } = data.data;
        if (data?.data?.status === 'success') {
            displayModal.value = false;
            await getTitulares();
            Swal.fire({
                title: "Titular registrado exitosamente",
                html: `
                  <p>${data?.data?.message}</p>
                  <p><strong>Correo:</strong> ${data?.data?.email ? data?.data?.email : data?.data?.data?.["Correo: "]}</p>
                  <p><strong>Contraseña:</strong> ${data?.data?.password ? data?.data?.password : data?.data?.data?.["Contraseña: "]}</p>
                `,
                icon: "success",
                confirmButtonText: "Aceptar",
            });
        } else {
            displayModal.value = false;
            Swal.fire({
                title: "Se ha producido un error al registrar el titular",
                text: data?.message?.response?.data?.message,
                icon: "error",
                confirmButtonText: "Aceptar",
            });
        }
    };


    // Funcion para baja Usuario
    const bajaNuevoTitular = async (form) => {
        const { data: info } = await store.dispatch("admin/bajaAltaUsuario", form);
        const { status, message } = info;
        if (status === 'success') {
            displayModal.value = false;
            await getTitulares();
            Swal.fire({
                title: "Usuario dado de baja exitosamente",
                text: message,
                icon: "success",
                confirmButtonText: "Aceptar",
            })
        } else {
            displayModal.value = false;
            Swal.fire({
                title: "Se ha producido un error al dar de baja el usuario",
                text: message,
                icon: "error",
                confirmButtonText: "Aceptar",
            })
        }
    };

    // Funcion para alta Usuario
    const altaNuevoTitular = async (form) => {
        const { data: info } = await store.dispatch("admin/bajaAltaUsuario", form);

        const { status, message } = info;
        if (status === 'success') {
            displayModal.value = false;
            await getTitulares();
            Swal.fire({
                title: "Usuario dado de alta exitosamente",
                text: message,
                icon: "success",
                confirmButtonText: "Aceptar",
            })
        } else {
            displayModal.value = false;
            Swal.fire({
                title: "Se ha producido un error al dar de alta el usuario",
                text: message,
                icon: "error",
                confirmButtonText: "Aceptar",
            })
        }
    };

    // Funcion para Editar usuario
    const editarTitular = async (form) => {
        const data = await store.dispatch("admin/editarUsuario", form);
        const { status, message } = data.data;
        if (status === 'success') {
            displayModal.value = false;
            await getTitulares();
            Swal.fire({
                title: "Usuario editado exitosamente",
                text: message,
                icon: "success",
                confirmButtonText: "Aceptar",
            })
            return true
        } else {
            const error = data.data.error;
            displayModal.value = false;
            Swal.fire({
                title: "Se ha producido un error al editar el usuario",
                text: error,
                icon: "error",
                confirmButtonText: "Aceptar",
            })
            return false
        }
    };


    // Validar curp usuario
    const validarCurpTitular = async (form) => {
        const data = await store.dispatch("admin/validarCurpTitular", form);
        return data;
    };

    return {
        displayModal,
        validarCurpTitular,
        getTitulares,
        getTitularesInfo,
        crearNuevoTitular,
        editarTitular,
        bajaNuevoTitular,
        altaNuevoTitular
    };
};

export default useDialogCrearTitulares;